module.exports = __webpack_public_path__ + "static/media/my_assets_setting.8a8361a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_setting.png
// module id = 751
// module chunks = 0 1